// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { harvestSessionId } from './HarvestSession';
import { harvestProtocolId } from './HarvestProtocol';
import { operatorId } from './Operator';
import { harvestScaleId } from './HarvestScale';
import { harvestOutcomeEnum } from './HarvestOutcomeEnum';
import { z } from 'zod';
export const harvestId = (z.number());
export const harvest = z.object({
    id: harvestId,
    fermentation_id: fermentationId,
    harvest_session_id: harvestSessionId.nullable(),
    harvest_protocol_id: harvestProtocolId.nullable(),
    planned_starting_weight_kg: z.string().nullable(),
    assigned_operator_id: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    performed_at: z.date().nullable(),
    harvest_number: z.number(),
    tags: z.string().array().nullable(),
    scale_id: harvestScaleId,
    outcome: harvestOutcomeEnum.nullable(),
    branches_frozen_at: z.date().nullable(),
    code: z.string(),
});
export const harvestInitializer = z.object({
    id: harvestId.optional(),
    fermentation_id: fermentationId,
    harvest_session_id: harvestSessionId.optional().nullable(),
    harvest_protocol_id: harvestProtocolId.optional().nullable(),
    planned_starting_weight_kg: z.string().optional().nullable(),
    assigned_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    performed_at: z.date().optional().nullable(),
    harvest_number: z.number(),
    tags: z.string().array().optional().nullable(),
    scale_id: harvestScaleId,
    outcome: harvestOutcomeEnum.optional().nullable(),
    branches_frozen_at: z.date().optional().nullable(),
    code: z.string(),
});
export const harvestMutator = z.object({
    id: harvestId.optional(),
    fermentation_id: fermentationId.optional(),
    harvest_session_id: harvestSessionId.optional().nullable(),
    harvest_protocol_id: harvestProtocolId.optional().nullable(),
    planned_starting_weight_kg: z.string().optional().nullable(),
    assigned_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    performed_at: z.date().optional().nullable(),
    harvest_number: z.number().optional(),
    tags: z.string().array().optional().nullable(),
    scale_id: harvestScaleId.optional(),
    outcome: harvestOutcomeEnum.optional().nullable(),
    branches_frozen_at: z.date().optional().nullable(),
    code: z.string().optional(),
});
//# sourceMappingURL=Harvest.js.map